<template>
  <article>
    <PageHeader
      :uuid="id"
      :name="name"
      :image-url="imageUrl">
      <template v-slot:description>
        <MarkdownText
          class="lead"
          :text="description"
          @clicked:link="trackLinkClick"/>
      </template>
    </PageHeader>

    <main class="collection-container">
      <div class="container">
        <div class="row">
          <div class="col-sm-4 hidden-xs" v-stickybits="stickyBitsOptions">
            <PageTOC :entries="tocEntries" />
          </div>
          <div class="col-sm-8 content-list-container">
            <div
              v-for="c of content"
              :key="c.content_uuid">
              <SectionHeading
                v-if="c.content_type === ContentTypes.TEXT_HEADER"
                :id="c.content_uuid"
                :text="c.text" />
              <Paragraph v-else-if="c.content_type === ContentTypes.TEXT_RICH_TEXT" :id="c.content_uuid">
                <MarkdownText :text="c.text" @clicked:link="trackLinkClick"/>
              </Paragraph>
              <ContentCard
                v-else-if="c.content_type === ContentTypes.STRATEGY"
                label="Strategy Page"
                :image-url="c.content_thumbnail_url"
                :title="c.content_title">
                <template v-slot:description><MarkdownText :text="c.text" @clicked:link="trackLinkClick"/></template>
                <template v-slot:bar>
                  <router-link
                    :to="{ name: 'StrategyDetailPage', params: { slugOrUuid: c.content_body.slug } }"
                    class="btn btn-primary"
                    @click.native="trackStrategyClick(c.content_body)"
                    target="_blank">
                    View Strategy
                  </router-link>
                  &nbsp;&nbsp;
                  <span class="text-muted" v-if="c.content_body.resource_count > 0"><i class="fa fa-download"/> {{ c.content_body.resource_count }}</span>
                </template>
              </ContentCard>

              <ContentCard
                v-else-if="c.content_type === ContentTypes.RESOURCE"
                label="Printable Resource"
                :image-url="c.content_thumbnail_url"
                :title="c.content_title">
                <template v-slot:description><MarkdownText :text="c.text" @clicked:link="trackLinkClick"/></template>
                <template v-slot:bar>
                  <ResourceDownloadButton :resource="c.content_body" />
                </template>
              </ContentCard>
            </div>
          </div>
        </div>
      </div>
    </main>
  </article>
</template>

<script>
import '@/imagekit/index'
import PageHeader from './PageHeader'
import PageTOC from './PageTOC'
import ContentCard from './ContentCard'
import SectionHeading from './SectionHeading'
import Paragraph from './Paragraph'
import { ContentTypes } from './content_types'
import MarkdownText from '@/components/MarkdownText'
import ResourceDownloadButton from '@/components/ResourceDownloadButton'

export default {
  name: 'CollectionDetail',
  components: {
    PageHeader,
    PageTOC,
    ContentCard,
    SectionHeading,
    Paragraph,
    MarkdownText,
    ResourceDownloadButton
  },
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    content: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      ContentTypes,
      stickyBitsOptions: {
        minWidth: 768,
        options: {
          stickyBitStickyOffset: 20
        }
      }
    }
  },
  computed: {
    tocEntries() {
      let headings = this.content.filter(c => c.content_type === ContentTypes.TEXT_HEADER)
      return headings.map(h => ({
        text: h.text,
        target: h.content_uuid
      }))
    }
  },
  methods: {
    trackLinkClick({ text, url }) {
      this.$sendEvent('Clicked External Link', {
        text,
        url
      })
    },
    trackStrategyClick(strategy) {
      this.$sendEvent('Clicked Curated Collection Strategy', {
        strategy_uuid: strategy.uuid,
        strategy_title: strategy.title
      })
    }
  }
}
</script>

<style lang="less" scoped>
.collection-container {
  background: #f8f8f8;
  padding-top: 3em;
  padding-bottom: 6em;

  .content-list-container {
    margin-top: -6em; // this offset matches the margin-top in SectionHeading.vue
  }
}
</style>
